import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "farm-slider__navigation" }
const _hoisted_2 = { class: "farm-slider__pagination" }
const _hoisted_3 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmSliderItem = _resolveComponent("FarmSliderItem")!
  const _component_FarmSliderProgress = _resolveComponent("FarmSliderProgress")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["FarmSlider farm-slider", [`is--items-${_ctx.farmCount}`, { 'is--logged-in': _ctx.isLoggedIn }]])
  }, [
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: _ctx.isMounted ? 'slide' : ''
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitedFarmList, (farm, i) => {
          return (_openBlock(), _createBlock(_component_FarmSliderItem, {
            key: farm.id,
            visible: _ctx.page === (i + 1),
            "farm-data": farm,
            onMouseenter: _ctx.onMouseEnter,
            onMouseleave: _ctx.onMouseLeave
          }, null, 8, ["visible", "farm-data", "onMouseenter", "onMouseleave"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["name"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_component_FarmSliderProgress, { key: _ctx.page })),
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmCount, (p) => {
          return (_openBlock(), _createElementBlock("li", {
            key: p,
            class: _normalizeClass(["farm-slider__pagination-item", { 'is--active': _ctx.page === p }]),
            onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
            onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
          }, [
            _createElementVNode("button", {
              class: "farm-slider__pagination-item-button",
              "aria-label": `Farm slider pagination button ${p}`,
              type: "button",
              onClick: ($event: any) => (_ctx.setActivePage(p))
            }, null, 8, _hoisted_3)
          ], 34))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.farmCount > 1]
    ])
  ], 2))
}